// Mobile Size Variants Handler
class MobileSizeVariants {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Find all mobile size variant containers
    const mobileContainers = document.querySelectorAll('.size-variants-mobile');
    
    mobileContainers.forEach(container => {
      this.initializeContainer(container);
    });
  }

  initializeContainer(container) {
    const radioInputs = container.querySelectorAll('input[type="radio"]');
    const labels = container.querySelectorAll('label');

    // Set initial active state
    this.updateVisualState(container);

    // Add click handlers to labels - only handle visual state
    labels.forEach(label => {
      label.addEventListener('click', (e) => {
        // Prevent default to avoid double triggering
        e.preventDefault();
        
        const input = container.querySelector(`#${label.getAttribute('for')}`);
        if (input && !input.disabled && !input.classList.contains('disabled')) {
          // Check the input and trigger change event
          input.checked = true;
          
          // Trigger change event for Shopify variant handling
          const changeEvent = new Event('change', { bubbles: true });
          input.dispatchEvent(changeEvent);
          
          // Update visual state
          this.updateVisualState(container);
        }
      });
    });

    // Listen for input changes to update visual state
    radioInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          this.updateVisualState(container);
        }
      });
    });
  }

  updateVisualState(container) {
    const allLabels = container.querySelectorAll('label');
    const checkedInput = container.querySelector('input[type="radio"]:checked');
    
    // Reset all labels to default state
    allLabels.forEach(label => {
      label.classList.remove('active', 'is-selected');
      const inputId = label.getAttribute('for');
      const input = container.querySelector(`#${inputId}`);
      
      // Check if input is disabled
      const isDisabled = input && (input.disabled || input.classList.contains('disabled'));
      
      if (isDisabled) {
        // Apply disabled styles
        label.style.background = '#fff';
        label.style.backgroundColor = '#fff';
        label.style.borderColor = '#E4E3E5';
        label.style.color = 'rgba(0,0,0,0.4)';
        label.style.textDecoration = 'line-through';
        label.style.cursor = 'not-allowed';
      } else {
        // Apply default styles
        label.style.background = '#fff';
        label.style.backgroundColor = '#fff';
        label.style.borderColor = '#E4E3E5';
        label.style.color = '#000';
        label.style.textDecoration = 'none';
        label.style.cursor = 'pointer';
      }
    });
    
    // Apply active state to checked input's label
    if (checkedInput) {
      const activeLabel = container.querySelector(`label[for="${checkedInput.id}"]`);
      const isDisabled = checkedInput.disabled || checkedInput.classList.contains('disabled');
      
      if (activeLabel && !isDisabled) {
        activeLabel.classList.add('active', 'is-selected');
        // Apply active styles directly with highest priority
        activeLabel.style.background = '#E4E3E5';
        activeLabel.style.backgroundColor = '#E4E3E5';
        activeLabel.style.borderColor = '#E4E3E5';
        activeLabel.style.color = '#000';
        activeLabel.style.textDecoration = 'none';
        activeLabel.style.cursor = 'pointer';
        
        console.log('Applied active styles to:', activeLabel, 'for input:', checkedInput.value);
      }
    }
  }
}

// Initialize when script loads
new MobileSizeVariants();
